<template>
  <div class="vote">
    <p class="vote__label">
      {{ label }}:
    </p>

    <div class="vote__wrap">
      <div class="vote__up">
        <button
          class="vote__button vote__button--up"
          :class="{'vote__button--voted': hasVotedUp}"
          @click="onVoteUp"
        >
          <span class="sr-only">{{ upVoteText }}</span>
          <p class="vote__print-text">
            +
          </p>
        </button>
        <span class="vote__score">
          {{ scoreUp }}
        </span>
      </div>

      <div class="vote__down">
        <span class="vote__score">
          {{ scoreDown }}
        </span>

        <button
          :class="{'vote__button--voted': hasVotedDown}"
          class="vote__button vote__button--down"
          @click="onVoteDown"
        >
          <span class="sr-only">{{ downVoteText }}</span>
          <p class="vote__print-text">
            -
          </p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import API from '../js/modules/api';

export default {
  name: 'Vote',

  props: {
    label: {
      type: String,
      required: true,
    },

    upVotes: {
      required: false,
      type: Number,
      default: 0,
    },

    upVoteText: {
      required: false,
      type: String,
      default: 'Vote up',
    },

    downVoteText: {
      required: false,
      type: String,
      default: 'Vote down',
    },

    downVotes: {
      required: false,
      type: Number,
      default: 0,
    },

    itemId: {
      type: [String, Number],
      required: true,
    },

    featureId: {
      type: [String, Number],
      required: true,
    },
  },

  data: () => ({
    hasVotedUp: false,
    hasVotedDown: false,
    voteUpClicked: false,
    voteDownClicked: false,
  }),

  computed: {
    uid() {
      return `${this.itemId}-${this.featureId}`;
    },

    scoreUp() {
      return (this.hasVotedUp && this.voteUpClicked) ? this.upVotes + 1 : this.upVotes;
    },

    scoreDown() {
      return (this.hasVotedDown && this.voteDownClicked) ? this.downVotes + 1 : this.downVotes;
    },
  },

  created() {
    try {
      const { hasVotedUp, hasVotedDown } = JSON.parse(localStorage.getItem(this.uid));

      this.hasVotedUp = hasVotedUp;
      this.hasVotedDown = hasVotedDown;
      // eslint-disable-next-line no-empty
    } catch (_) {
    }
  },

  methods: {
    onVoteUp() {
      const localVotedUp = this.hasVotedUp;
      const localVotedDown = this.hasVotedDown;

      this.voteUpClicked = true;
      this.hasVotedUp = !this.hasVotedUp;
      this.hasVotedDown = false;
      this.saveVotesInLocalStorage();

      return API()
        .vote({
          direction: 'up',
          itemId: this.itemId,
          featureId: this.featureId,
          hasVotedUp: localVotedUp,
          hasVotedDown: localVotedDown,
        });
    },

    onVoteDown() {
      const localVotedUp = this.hasVotedUp;
      const localVotedDown = this.hasVotedDown;

      this.voteDownClicked = true;
      this.hasVotedDown = !this.hasVotedDown;
      this.hasVotedUp = false;
      this.saveVotesInLocalStorage();

      return API()
        .vote({
          direction: 'down',
          itemId: this.itemId,
          featureId: this.featureId,
          hasVotedUp: localVotedUp,
          hasVotedDown: localVotedDown,
        });
    },

    saveVotesInLocalStorage() {
      localStorage.setItem(this.uid, JSON.stringify({
        hasVotedUp: this.hasVotedUp,
        hasVotedDown: this.hasVotedDown,
      }));
    },
  },
};
</script>
